// Used in notifications.module.ts

// Angular
import {
    AfterViewInit,
    Component,
    EventEmitter,
    OnInit,
    Output,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Store, select } from "@ngrx/store";

// Services/Types/Helpers
import { TimezoneHelper } from "#helpers/timezone.helper";
import { LocalStorage } from "#services/local-storage.service";
import { Course, Language, Notification, PPUser as User } from "cli-types";

// RXJS/Store
import * as fromStore from "#login/store";
import { Observable } from "rxjs";

// Moment
import { CoursePaginationParameters, CoursesService, LanguageService, NotificationService } from "@carnegie-learning/data-access-angular-passport";
import Moment from "moment";

@Component({
    selector: "new-notification",
    templateUrl: "./notification.component.html",
    styleUrls: [
        "../../notifications.component.scss",
        "./notification.component.scss",
    ],
    standalone: false
})
export class NotificationComponent implements OnInit, AfterViewInit {
    courses?: Course[];
    languages?: Language[];
    loading = false;

    isTeacher: Observable<boolean>;
    isDistributor: Observable<boolean>;
    isMaximized = false;

    confirmSent = false;

    // Default values for table
    params: CoursePaginationParameters = {
        limit: 1000,
        page: 0,
        filter: { archived: false }, // true - only archived records, false - only active records, don't include param means everything
        search: "",
        sorting: { courseTitle: "asc" },
        // withCourseMetrics filter flag is slow, use with caution.
        withCourseMetrics: false,
        total: 0,
    };
    userData?: User;

    @Output() cancel = new EventEmitter<any>();
    @Output() goToInbox = new EventEmitter<void>();

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private notificationService: NotificationService,
        private coursesService: CoursesService,
        private languageService: LanguageService,
        public store: Store<fromStore.UserState>,
        private localStorage: LocalStorage,
        private timezoneHelper: TimezoneHelper
    ) {
        this.isTeacher = this.store.pipe(select(fromStore.getIsTeacher));
        this.isDistributor = this.store.pipe(
            select(fromStore.getIsDistributor)
        );
    }

    ngOnInit() {
        this.loading = true;
        this.isMaximized =
            this.router.url === "/teacher/send-notification" ? true : false;

        this.coursesService.getCourses(this.params).subscribe((data) => {
            this.loading = false;

            // Only include Classes with students
            const classesWithStudents: Course[] = [];
            data.data.forEach((c) => {
                if (c.students.length > 0) {
                    classesWithStudents.push(c);
                }
            });
            this.courses = classesWithStudents;
        });

        this.languageService.publicLanguages().subscribe((data) => {
            this.loading = false;
            this.languages = data;
        });
    }

    ngAfterViewInit() {}

    sendNotification(notification: Notification) {
        // format Dates for api
        this.loading = true;

        this.userData = this.localStorage.get("userProfile");

        notification.displayAt =
            notification.displayAt && this.userData
                ? this.timezoneHelper.convertUserDateToServerTZ(
                      Moment(notification.displayAt).format(
                          "YYYY-MM-DD HH:mm:ss"
                      ),
                      this.userData.timezone
                  )
                : null;

        notification.expireAt =
            notification.expireAt && this.userData
                ? this.timezoneHelper.convertUserDateToServerTZ(
                      Moment(notification.expireAt).format(
                          "YYYY-MM-DD HH:mm:ss"
                      ),
                      this.userData.timezone
                  )
                : null;

        this.notificationService
            .sendNotification(notification)
            .subscribe((response) => {
                this.loading = false;
                this.confirmSent = true;
            });
    }

    okay() {
        this.confirmSent = false;
        this.goToInbox.emit();
    }

    onClickCancel() {
        this.cancel.emit();
    }
}
